module.exports = __webpack_public_path__ + "img/juice.50369759.jpg";